import { RouteObject } from 'react-router-dom';

import {
  LeaveRequest,
  TaskList,
  ApprovalFormResolver,
  ITRequisition,
  ManageRequests,
  PassportRequest,
  SalaryCertificate,
  OverseasMission,
  ResumptionRequests,
  ResumptionRequestCreate,
  ResumptionRequestEdit,
  AttendanceRequest,
  AttendanceRequestCreateForm,
  AttendanceRequestEditForm,
} from '@Features/index';

import {
  LeaveRequestCreateForm,
  LeaveRequestEditForm,
} from '@Features/EmployeeSelfService/requests/LeaveRequest/form';

import {
  PassportRequestCreateForm,
  PassportRequestEditForm,
} from '@Features/EmployeeSelfService/requests/PassportRequest/form';

import {
  SalaryCertificateCreateForm,
  SalaryCertificateEditForm,
} from '@Features/EmployeeSelfService/requests/SalaryCertificate/form';

import {
  OverseasMissionCreateForm,
  OverseasMissionEditForm,
} from '@Features/EmployeeSelfService/requests/OverseasMission/form';

import {
  ITRequestCreateForm,
  ITRequestEditForm,
} from '@Features/EmployeeSelfService/requests/ITRequisition/form';

// TODO: Hide Resignation request by 1631 task
import {
  ResignationRequestCreate,
  ResignationRequests,
  ResignationRequestEdit,
} from '@Features//EmployeeSelfService/requests/ResignationRequests';

import ProfilePage from '@Pages/ProfilePage/ProfilePage';
import ProfileDetails from '@Pages/ProfilePage/ProfileDetails/ProfileDetails';
import { getITReqEnable, getResignationEnable } from '@Utils/getFeatureFlag';
import ESSFeatureRoutePath from './ESSFeatureRoutePath.enum';

// TODO: feature flag for dev env
const isITReqEnable = getITReqEnable();
const isResignationEnable = getResignationEnable();

const resignationRoute = {
  path: ESSFeatureRoutePath.MANAGE_REQUEST_RESIGNATION_REQUESTS,
  element: <ResignationRequests />,
  children: [
    {
      path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_RESIGNATION_REQUEST,
      element: <ResignationRequestCreate />,
    },
    {
      path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_RESIGNATION_REQUEST,
      element: <ResignationRequestEdit />,
    },
  ],
};

const itReqRoute = {
  path: ESSFeatureRoutePath.MANAGE_REQUEST_IT_REQUISITION,
  element: <ITRequisition />,
  children: [
    {
      path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_IT_REQUISITION,
      element: <ITRequestCreateForm />,
    },
    {
      path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_IT_REQUISITION,
      element: <ITRequestEditForm />,
    },
  ],
};

const essChildrenRoutes = [
  {
    path: ESSFeatureRoutePath.MANAGE_REQUEST_LEAVE_REQUEST,
    element: <LeaveRequest />,
    children: [
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_LEAVE_REQUEST,
        element: <LeaveRequestCreateForm />,
      },
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_LEAVE_REQUEST,
        element: <LeaveRequestEditForm />,
      },
    ],
  },
  {
    path: ESSFeatureRoutePath.MANAGE_REQUEST_PASSPORT_REQUEST,
    element: <PassportRequest />,
    children: [
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_PASSPORT_REQUEST,
        element: <PassportRequestCreateForm />,
      },
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_PASSPORT_REQUEST,
        element: <PassportRequestEditForm />,
      },
    ],
  },
  {
    path: ESSFeatureRoutePath.MANAGE_REQUEST_SALARY_CERTIFICATE,
    element: <SalaryCertificate />,
    children: [
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_SALARY_CERTIFICATE,
        element: <SalaryCertificateCreateForm />,
      },
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_SALARY_CERTIFICATE,
        element: <SalaryCertificateEditForm />,
      },
    ],
  },
  {
    path: ESSFeatureRoutePath.MANAGE_REQUEST_OVERSEAS_MISSION,
    element: <OverseasMission />,
    children: [
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_OVERSEAS_MISSION,
        element: <OverseasMissionCreateForm />,
      },
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_OVERSEAS_MISSION,
        element: <OverseasMissionEditForm />,
      },
    ],
  },
  {
    path: ESSFeatureRoutePath.MANAGE_REQUEST_RESUMPTION_REQUESTS,
    element: <ResumptionRequests />,
    children: [
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_RESUMPTION_REQUEST,
        element: <ResumptionRequestCreate />,
      },
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_RESUMPTION_REQUEST,
        element: <ResumptionRequestEdit />,
      },
    ],
  },
  {
    path: ESSFeatureRoutePath.MANAGE_REQUEST_ATTENDANCE_REQUEST,
    element: <AttendanceRequest />,
    children: [
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_ATTENDANCE_REQUEST,
        element: <AttendanceRequestCreateForm />,
      },
      {
        path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_ATTENDANCE_REQUEST,
        element: <AttendanceRequestEditForm />,
      },
    ],
  },
];

const routerChildrens = [...essChildrenRoutes];

if (isITReqEnable) {
  routerChildrens.push(itReqRoute);
}

if (isResignationEnable) {
  routerChildrens.push(resignationRoute);
}

const featureESSRouter: RouteObject[] = [
  {
    path: '/ess',
    children: [
      {
        path: ESSFeatureRoutePath.MANAGE_REQUESTS,
        element: <ManageRequests />,
        children: routerChildrens,
        // children: [
        //   {
        //     path: ESSFeatureRoutePath.MANAGE_REQUEST_LEAVE_REQUEST,
        //     element: <LeaveRequest />,
        //     children: [
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_LEAVE_REQUEST,
        //         element: <LeaveRequestCreateForm />,
        //       },
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_LEAVE_REQUEST,
        //         element: <LeaveRequestEditForm />,
        //       },
        //     ],
        //   },
        //   {
        //     path: ESSFeatureRoutePath.MANAGE_REQUEST_PASSPORT_REQUEST,
        //     element: <PassportRequest />,
        //     children: [
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_PASSPORT_REQUEST,
        //         element: <PassportRequestCreateForm />,
        //       },
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_PASSPORT_REQUEST,
        //         element: <PassportRequestEditForm />,
        //       },
        //     ],
        //   },
        //   {
        //     path: ESSFeatureRoutePath.MANAGE_REQUEST_SALARY_CERTIFICATE,
        //     element: <SalaryCertificate />,
        //     children: [
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_SALARY_CERTIFICATE,
        //         element: <SalaryCertificateCreateForm />,
        //       },
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_SALARY_CERTIFICATE,
        //         element: <SalaryCertificateEditForm />,
        //       },
        //     ],
        //   },
        //   {
        //     path: ESSFeatureRoutePath.MANAGE_REQUEST_OVERSEAS_MISSION,
        //     element: <OverseasMission />,
        //     children: [
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_OVERSEAS_MISSION,
        //         element: <OverseasMissionCreateForm />,
        //       },
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_OVERSEAS_MISSION,
        //         element: <OverseasMissionEditForm />,
        //       },
        //     ],
        //   },
        //   // {
        //   //   path: ESSFeatureRoutePath.MANAGE_REQUEST_IT_REQUISITION,
        //   //   element: <ITRequisition />,
        //   //   children: [
        //   //     {
        //   //       path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_IT_REQUISITION,
        //   //       element: <ITRequestCreateForm />,
        //   //     },
        //   //     {
        //   //       path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_IT_REQUISITION,
        //   //       element: <ITRequestEditForm />,
        //   //     },
        //   //   ],
        //   // },
        //   {
        //     path: ESSFeatureRoutePath.MANAGE_REQUEST_RESUMPTION_REQUESTS,
        //     element: <ResumptionRequests />,
        //     children: [
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_RESUMPTION_REQUEST,
        //         element: <ResumptionRequestCreate />,
        //       },
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_RESUMPTION_REQUEST,
        //         element: <ResumptionRequestEdit />,
        //       },
        //     ],
        //   },
        //   {
        //     path: ESSFeatureRoutePath.MANAGE_REQUEST_ATTENDANCE_REQUEST,
        //     element: <AttendanceRequest />,
        //     children: [
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_ATTENDANCE_REQUEST,
        //         element: <AttendanceRequestCreateForm />,
        //       },
        //       {
        //         path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_ATTENDANCE_REQUEST,
        //         element: <AttendanceRequestEditForm />,
        //       },
        //     ],
        //   },
        //   // {
        //   //   path: ESSFeatureRoutePath.MANAGE_REQUEST_RESIGNATION_REQUESTS,
        //   //   element: <ResignationRequests />,
        //   //   children: [
        //   //     {
        //   //       path: ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_RESIGNATION_REQUEST,
        //   //       element: <ResignationRequestCreate />,
        //   //     },
        //   //     {
        //   //       path: ESSFeatureRoutePath.MANAGE_REQUEST_EDIT_RESIGNATION_REQUEST,
        //   //       element: <ResignationRequestEdit />,
        //   //     },
        //   //   ],
        //   // },
        // ],
      },
      {
        path: ESSFeatureRoutePath.APPROVALS,
        element: <TaskList />,
        children: [
          {
            path: ESSFeatureRoutePath.TASK_APPROVE_REQUEST,
            element: <ApprovalFormResolver />,
          },
        ],
      },
      {
        path: ESSFeatureRoutePath.PROFILE,
        element: <ProfilePage />,
        children: [
          {
            path: ESSFeatureRoutePath.PROFILE_DETAILS,
            element: <ProfileDetails />,
          },
        ],
      },
    ],
  },
];

export default featureESSRouter;
